// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Favourites_pageHeader__ZZAoK","favourites":"Favourites_favourites__2hjBb"};